class colorSwatchCard extends HTMLElement {

    constructor() {
        super();
        
        this.customVariantsScript = null;
        this.fullMediaScript = null;
        this.customVariantData = null;
        this.currentVariant = null;
        this.metaImages = [];
        this.imgElement = null;
        for (let elm of document.querySelectorAll(".product-card-wrapper img")) {
            elm.addEventListener('click', this.onImageClick);
        }
        for (let elm of document.querySelectorAll(".product-card-wrapper input[name='Color']")) {
            elm.addEventListener('click', this.onColorChange);
        }
    }
    
    onImageClick(event) {
        location.href = event.target.dataset.href;
    }    
    
    onColorChange(event) {        
       let inputRadioList = event.target.closest('.product-card-wrapper').querySelectorAll("input[name='Color']");
           inputRadioList.forEach((inputRadio)=> {
               inputRadio.classList.remove("current");
           }
        );
        event.target.classList.add("current");
        
        this.customVariantsScript = document.querySelector('#CustomVariantsScript-' + event.target.dataset.productid);
        if(this.customVariantsScript == null || this.customVariantsScript == undefined) {
           return false;
        }
          // I filter all the variants that match the selected color and have images
        this.customVariantData = JSON.parse(this.customVariantsScript.textContent).filter(function (item) {
            return item.color == event.target.value && item.meta_images != undefined && item.meta_images != []
        });
        
        if(this.customVariantData.length > 0) {
            // First, I look for a variant that is available (available = true) with this color
            const availableVariant = this.customVariantData.find(variant => variant.available === true);
            // If there is an available variant, I use that one; otherwise, I use the first variant with this color, even if it’s not available, in order to still display the image
            this.currentVariant = availableVariant || this.customVariantData[0];    
            let productLinks = event.target.closest('.product-card-wrapper').querySelectorAll('a');
                productLinks.forEach((productLink)=> {
                    if(this.currentVariant.url.indexOf('&') == -1) {
                        productLink.href = this.currentVariant.url + '?variant=' + this.currentVariant.id;
                    } else {
                        productLink.href = this.currentVariant.url + '&variant=' + this.currentVariant.id;
                    }
                }
            );
                
            let productImages = event.target.closest('.product-card-wrapper').querySelectorAll('img');
                productImages.forEach((productImage)=> {
                    if(this.currentVariant.url.indexOf('&') == -1) {
                        productImage.dataset.href = this.currentVariant.url + '?variant=' + this.currentVariant.id;
                    } else {
                        productImage.dataset.href = this.currentVariant.url + '&variant=' + this.currentVariant.id;
                    }
                }
            );
            
            if (this.currentVariant.meta_images && event.target.closest('.product-card-wrapper').querySelector('#media-images-' + this.currentVariant.id) != null) {    
                let productImageBlocks = event.target.closest('.product-card-wrapper').querySelectorAll('.media--hover-effect');
                    productImageBlocks.forEach((productImageBlock)=> {
                        productImageBlock.classList.add("tw-hidden");
                    }
                );
                event.target.closest('.product-card-wrapper').querySelector('#media-images-' + this.currentVariant.id).classList.remove("tw-hidden");
            }
            
            if (event.target.closest('.product-card-wrapper').querySelector('#prices-' + this.currentVariant.id) != null) {    
                let prices = event.target.closest('.product-card-wrapper').querySelectorAll('.showpricing');
                    prices.forEach((price)=> {
                    	price.classList.add("tw-hidden");
                    }
                );
                event.target.closest('.product-card-wrapper').querySelector('#prices-' + this.currentVariant.id).classList.remove("tw-hidden");
            }

            if (this.closest('color-swatch-card').getAttribute('data-position') == "pdp" || this.closest('color-swatch-card').getAttribute('data-position') == "minicart" || this.closest('color-swatch-card').getAttribute('data-position') == "cart") {
                let form = event.target.closest('.product-card-wrapper').querySelector('.product-form');
                let submitButton = form.querySelector('.product-form__submit');
                let variantInput = form.querySelector('.product-variant-id');

                variantInput.value = this.currentVariant.id;

                if (this.currentVariant.available) {
                    submitButton.disabled = false;
                    submitButton.querySelector('span').innerHTML = 'ADD TO CART';
                }
            }
        }
    }
}

customElements.define('color-swatch-card', colorSwatchCard);


